import { Ownership } from '../@types/ownership'

export const isOwnerOrPartialOwner = (ownership?: Ownership): boolean =>
  !!ownership && (ownership == Ownership.YES || ownership == Ownership.CO_OWNER)
